import { useZaiSideChatModel } from './zai-side-chat.model'
import { ZaiSideChatView } from './zai-side-chat.view'

import './zai-side-chat.styles.scss'

export const ZaiSideChat = () => {
  const model = useZaiSideChatModel()

  return <ZaiSideChatView {...model} />
}
